//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

import { HomeLayout } from '../../layouts';
import { ClubEvent } from '../Calendar';
import { HeroCarousel } from './HeroCarousel';
import { Discriminators } from './Discriminators';
import { BootstrapIcon } from '../BootstrapIcon';
import { SpecialAnnouncements } from '../SpecialAnnouncements';

import * as choiceApi from '../../api/choice';

import './Home.css';

export function Home(props) {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        async function loadEvents() {
            const eventList = await choiceApi.getEvents();
            if (eventList) {
                setEvents(eventList);
            }
        }

        loadEvents();

    }, [])


    return (
        <HomeLayout>
            <HeroCarousel />
            <Container className="choice-social-description">
                <p>Choice Social Club is New England's premier private adult lifestyle club.</p>
                <p>We are pleased to offer you an 8,000 square foot upscale facility. Our community space is unrivaled in New England in terms of either size or amenities. It is arranged to cater to the fantasies and desires of like-minded adventurous adults. Rooms are decorated in warm tones and feature low lighting, leather furniture, hardwood floors, and oriental rugs. We feel that the elegance and comfort of the club venue reflects the attitudes of our membership.</p>
                <p>
                    <a href="https://www.youtube.com/watch?v=DeoORGdLNN0" className='text-decoration-none'>
                        <Button variant="dark" className="virtual-tour">
                            <div className="fs-3 me-2">
                                <BootstrapIcon variant={"danger"} icon="youtube" />
                            </div>
                            <div>
                                {' '}See the Virtual Tour
                            </div>
                        </Button> 
                    </a>
                </p>
            </Container>
            <Discriminators />
            <SpecialAnnouncements />
            <Container className="this-week-at-choice">
                <h1>This weekend @Choice</h1>
                <ClubEvent event={events[0]} />
            </Container>
            {/* <Featurettes /> */}
        </HomeLayout>
    );

}

